import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { Button } from '../ui/button';
import { LogIn, AlertCircle } from 'lucide-react';

const AdminLogin = () => {
  const { login } = useAuth();
  const location = useLocation();
  const error = location.state?.error;

  return (
    <div className="min-h-screen bg-[#1a1f1a] flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-[#2d5f3f] rounded-2xl p-8 shadow-xl">
          {/* Logo/Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-[#f5f3ed] mb-2">
              Equi-Go Admin
            </h1>
            <p className="text-[#f5f3ed]/70">
              Sign in to manage customers and bookings
            </p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-4 mb-6 flex items-start gap-3">
              <AlertCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" />
              <p className="text-red-200 text-sm">{error}</p>
            </div>
          )}

          {/* Info */}
          <div className="bg-[#1a1f1a]/30 rounded-lg p-4 mb-6">
            <p className="text-[#f5f3ed]/70 text-sm text-center">
              Access is restricted to authorized personnel only.
              <br />
              <span className="text-[#c9a55a]">enquiries@equi-go.co.uk</span>
            </p>
          </div>

          {/* Login Button */}
          <Button
            onClick={login}
            className="w-full bg-[#c9a55a] hover:bg-[#b8944a] text-[#1a1f1a] font-semibold py-6 rounded-xl transition-all duration-300"
            data-testid="admin-login-btn"
          >
            <LogIn className="w-5 h-5 mr-2" />
            Sign in with Google
          </Button>
        </div>

        {/* Back to main site */}
        <div className="text-center mt-6">
          <a 
            href="/" 
            className="text-[#f5f3ed]/50 hover:text-[#c9a55a] text-sm transition-colors"
          >
            ← Back to main site
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
